// extracted by mini-css-extract-plugin
export default {"label":"wIFoCavTqxtd51nUY2QU"};